import React, { useState, useEffect, useMemo } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "../../../../../components/ExportToExcel";
import Pagination from "../../../../../components/Pagination";
import SearchBar from "../../../../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Dynamic_FilterForm from "../../../../../components/Dynamic_FilterForm";
import { useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import Select from 'react-select';


const SupportTicketTable = ({

  data,
  selectedResource,
  selectAllChecked,
  columns,
  isSrNoRequired,ReadOnlyValues,
  isApiStatus,
  isRequiredStatus,
  defaultColumns,
  handleBtn,
  // itemsPerPage,
  searchTerm,
  setSearchTerm,
  handleReset,
  handleIconClick,
  handleModalColumn,
  handleColumnSelect,
  icons,
  isActionRequired,
  isCheckBoxRequired,
  isAddNewBtnRequired,
  isFilterRequired,
  isSorting,
  formDatas,
  showIcon1,
  showIcon2,
  showIcon3,
  showIcon4,
  showIcon5,
  handleIcon1,
  handleIcon2,
  handleIcon3,
  handleIcon4,
  handleIcon5,
  handleGetData,
  handleAddNew,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  handleSelectAllChange,
}) => {
  console.log("inside Tabel", isApiStatus);

  const [visibleColumns, setVisibleColumns] = useState(
    Object.keys(columns).reduce((acc, key) => {
      acc[key] = columns[key].visible; // Set initial visibility based on the 'visible' key
      return acc;
    }, {})
  );

  const [currentPage, setCurrentPage] = useState(1);
    const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
    const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const ExcelName = useSelector(({ layoutReducer }) => layoutReducer?.filterSlice?.navbarHeading)

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [columnName]: !prevState[columnName], // Toggle visibility
    }));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();

  console.log("data------>", data);

  const sortedData = useMemo(() => {
    let sortableItems = Array.isArray(data) ? [...data] : [];

    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        const valA = a[sortConfig.key] ? String(a[sortConfig.key]) : "";
        const valB = b[sortConfig.key] ? String(b[sortConfig.key]) : "";

        // Split the values into alphabetical and numeric parts
        const partsA = valA.match(/(\D+|\d+)/g) || [];
        const partsB = valB.match(/(\D+|\d+)/g) || [];

        for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
          const partA = partsA[i] || "";
          const partB = partsB[i] || "";

          // Determine if parts are numeric or alphabetical
          const isNumericA = !isNaN(partA);
          const isNumericB = !isNaN(partB);

          if (isNumericA && isNumericB) {
            // Both parts are numeric, so compare as numbers
            const numA = parseInt(partA, 10);
            const numB = parseInt(partB, 10);
            if (numA !== numB) {
              return sortConfig.direction === "ascending"
                ? numA - numB
                : numB - numA;
            }
          } else if (isNumericA || isNumericB) {
            // One part is numeric and the other is alphabetical
            return isNumericA ? -1 : 1;
          } else {
            // Both parts are alphabetical, so compare as strings
            if (partA !== partB) {
              return sortConfig.direction === "ascending"
                ? partA.localeCompare(partB)
                : partB.localeCompare(partA);
            }
          }
        }

        return 0;
      });
    }
    return sortableItems;
  }, [data, sortConfig]);

  const filteredData = sortedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  console.log("filteredData", filteredData);
  const exportData = filteredData.map((item) => ({
    TicketNo:item.ID,
    EmployeeName: item.EmployeeName,
    CategoryName: item.categoryName,
    SubCategoryName: item.subCategoryName,
    RaisedOn: item.TXNDate,
    Status: item.Status,
    Details: item.Details,
    ActionBy: item.actionByName,
    Priority:item.priorityName,
    ActionRemark:item.ActionRemark,
    ClosureDate:item.ClosureDate,
    TotalTime:item.time_difference
  }));


  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);

  const handleSort = (columnName) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === columnName &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key: columnName, direction });
  };

  //old code for date fromat
  // const formatDate = (date) => {
  //   if (!date) return ""; // Handle null or undefined dates

  //   // Check if the date is already in DD-MM-YYYY format
  //   const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
  //   if (dateRegex.test(date)) {
  //     return date;
  //   }

  //   return moment(date).format("DD-MMM-YYYY");
  // };

  //new updateed code for date fromat
  const formatDate = (date) => {
    if (!date) return ""; // check date is null or undefined

    // Use moment
    const parsedDate = moment(
      date,
      [
        moment.ISO_8601, // Handles ISO date formats
        "DD-MM-YYYY", // Specific format check
        "MM/DD/YYYY", // U.S. format
        "YYYY-MM-DD", // Standard format
      ],
      true
    );

    // Return formatted date if valid, otherwise an empty string
    return parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : "";
  };
 
  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];
  const [dropDownValue, setDropdownValue] = useState({});

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };

  return (
    <div className="container-fluid ">
  <div className="container-fluid p-0">
  {/* Mobile layout (hidden on desktop) */}
  <div className="row g-2 d-flex d-md-none" style={{ marginBottom: "-30px" }}>
    <div className="col-10">
      <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
    </div>
    {isFilterRequired && (
      <div className="col-2 dropdown">
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
        >
          <button
            className="dropdown-toggle"
            type="button"
            id="excel-btn"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="bi bi-funnel-fill"></i>
          </button>
        </OverlayTrigger>
        <div>
          <Dynamic_FilterForm
            formData={formDatas || []}
            handleReset={handleReset}
            handleChange={handleChange}
            handleGetData={handleGetData}
            filterFormData={filterFormData}
          />
        </div>
      </div>
    )}
  </div>

  {/* Stats for mobile */}
  <div className="row g-2 mb-2 d-flex d-md-none">
    <div className="col-12">
      <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '8px' }}>
        {ReadOnlyValues?.map((stat, index) => (
          <div 
            key={index}
            style={{
              backgroundColor: '#f8f9fa',
              padding: '4px 8px',
              borderRadius: '4px',
              height: "35px",
              border: '1px solid #dee2e6',
              whiteSpace: 'nowrap'
            }}
          >
            <span style={{ fontWeight: '600' }}>{stat.label}: </span>
            <span>
              {typeof stat.value === 'number' && stat.label.toLowerCase().includes('amount')
                ? stat.value.toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                    minimumFractionDigits: 2
                  })
                : stat.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  </div>

  {/* Mobile action buttons (hidden on desktop) */}
  <div className="row g-2 mb-2 d-flex d-md-none justify-content-end">
    <div className="col-auto">
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
      >
        <div>
          <ExportToExcel
            data={exportData}
            filename={`${ExcelName}.csv`}
          />
        </div>
      </OverlayTrigger>
    </div>
    <div className="col-auto">
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
      >
        <div className="btn-group" style={{ zIndex: 100 }}>
          <button
            type="button"
            className="dropdown-toggle skill-button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            id="excel-btn"
          >
            <i className="bi bi-list"></i>
          </button>
          <ul className="dropdown-menu p-2">
            <div
              className="row"
              style={{ maxHeight: "300px", overflowY: "auto" }}
            >
              <Form.Group>
                {Object.keys(columns).map((columnName) => (
                  <Form.Check
                    key={columnName}
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    type="checkbox"
                    id={`checkbox-${columnName}`}
                    label={columns[columnName].text}
                    checked={visibleColumns[columnName] || false}
                    onChange={() => toggleColumn(columnName)}
                  />
                ))}
              </Form.Group>
            </div>
          </ul>
        </div>
      </OverlayTrigger>
    </div>
    {isAddNewBtnRequired && (
      <div className="col-auto">
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
        >
          <button id="Add-btn" onClick={handleAddNew}>
            <i className="fa fa-plus"></i> Add
          </button>
        </OverlayTrigger>
      </div>
    )}
  </div>

  {/* Desktop layout (hidden on mobile) */}
  <div className="d-none d-md-flex justify-content-between">
    <div className="d-flex">
      <div className="me-1">
        <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      </div>
      {isFilterRequired && (
        <div className="dropdown">
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
          >
            <button
              className="dropdown-toggle"
              type="button"
              id="excel-btn"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="bi bi-funnel-fill"></i>
            </button>
          </OverlayTrigger>
          <div>
            <Dynamic_FilterForm
              formData={formDatas || []}
              handleReset={handleReset}
              handleChange={handleChange}
              handleGetData={handleGetData}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      )}
      <div style={{ display: 'flex', gap: '16px', marginLeft: '8px' }}>
        {ReadOnlyValues?.map((stat, index) => (
          <div 
            key={index}
            style={{
              backgroundColor: '#f8f9fa',
              padding: '4px 8px',
              borderRadius: '4px',
              height: "35px",
              border: '1px solid #dee2e6'
            }}
          >
            <span style={{ fontWeight: '600' }}>{stat.label}: </span>
            <span>
              {typeof stat.value === 'number' && stat.label.toLowerCase().includes('amount')
                ? stat.value.toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                    minimumFractionDigits: 2
                  })
                : stat.value}
            </span>
          </div>
        ))}
      </div>
    </div>

    <div className="d-flex justify-content-end">
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
      >
        <div className="me-1">
          <ExportToExcel
            data={exportData}
            filename={`${ExcelName}.csv`}
          />
        </div>
      </OverlayTrigger>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
      >
        <div className="btn-group me-2">
          <button
            type="button"
            className="dropdown-toggle skill-button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            id="excel-btn"
          >
            <i className="bi bi-list"></i>
          </button>
          <ul className="dropdown-menu p-2">
            <div className="row">
              <Form.Group>
                {Object.keys(columns).map((columnName) => (
                  <Form.Check
                    key={columnName}
                    type="checkbox"
                    id={`checkbox-${columnName}`}
                    label={columns[columnName].text}
                    checked={visibleColumns[columnName] || false}
                    onChange={() => toggleColumn(columnName)}
                  />
                ))}
              </Form.Group>
            </div>
          </ul>
        </div>
      </OverlayTrigger>
      {isAddNewBtnRequired && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
        >
          <button id="Add-btn" onClick={handleAddNew}>
            <i className="fa fa-plus"></i> Add
          </button>
        </OverlayTrigger>
      )}
    </div>
  </div>
</div>

      <div className=" ">
        <div className="table-responsive  mb-2">
          <Table striped bordered hover>
            <thead id="thcolor" className="text-center">
              <tr>
                {isCheckBoxRequired && (
                  <th style={{ width: "20px" }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectAllChecked}
                      onChange={(e) => handleSelectAllChange(e)}
                    />
                  </th>
                )}
                  {isSrNoRequired && <th>Sr. No.</th>}
                {Object.keys(columns).map((columnName) => {
                  const isDateColumn =
                    columns[columnName].text.toLowerCase().includes("date") ||
                    columns[columnName].text
                      .toLowerCase()
                      .includes("on bench since");

                  const columnAlignment = columns[columnName].align || "left";
                  const columnWidth = columns[columnName].width;
                  const isSelectColumn = columns[columnName].type === "Select";
                  const isButtonColumn = columns[columnName].type === "button";
                  const isModalColumn = columns[columnName].type === "Modal";
                  const isImageColumn = columns[columnName].type === "Image";
                  const isLinkColumn = columns[columnName].type === "Link";
                  const hasIcon = columns[columnName].icon;

                  return (
                    visibleColumns[columnName] && (
                      <th
                        style={{ whiteSpace: "nowrap" }}
                        key={columnName}
                        onClick={
                          isSorting &&
                            (isButtonColumn || isModalColumn || hasIcon)
                            ? undefined
                            : () => handleSort(columnName)
                        }
                      >
                        {columns[columnName].text}
                        {isSorting &&
                          !(isButtonColumn || isModalColumn || hasIcon) && (
                            <span className="ms-1">
                              {sortConfig.key === columnName ? (
                                sortConfig.direction === "ascending" ? (
                                  <i className="bi bi-chevron-up"></i>
                                ) : (
                                  <i className="bi bi-chevron-down"></i>
                                )
                              ) : (
                                <i className="bi bi-chevron-down"></i>
                              )}
                            </span>
                          )}
                      </th>
                    )
                  );
                })}
                {isActionRequired && <th>Action</th>}
              </tr>
            </thead>
            {isRequiredStatus ?
              (isApiStatus === 200 && currentData?.length != 0 ? (
                <tbody>
                  {currentData.map((item, index) => (
                    <tr key={index}>
                      {isCheckBoxRequired && (
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={
                              !!selectedResource.find(
                                (o) => o.EmployeeID === item.EmployeeID
                              )
                            }
                            onChange={(e) =>
                              handleCheckboxChange(e, item.EmployeeID, item)
                            }
                          />
                        </td>
                      )}
                          {isSrNoRequired && (
                        <td className="text-center">{index + 1}</td>
                      )}
                      {Object.keys(columns).map((columnName) => {
                        const isDateColumn =
                          columns[columnName].text.toLowerCase().includes("date") ||
                          columns[columnName].text
                            .toLowerCase()
                            .includes("on bench since");

                        const columnAlignment = columns[columnName].align || "left";
                        const columnWidth = columns[columnName].width;

                        const isButtonColumn =
                          columns[columnName].type === "button";
                        const isModalColumn = columns[columnName].type === "Modal";
                        const isImageColumn = columns[columnName].type === "Image";
                        const isLinkColumn = columns[columnName].type === "Link";
                        const isSelectColumn = columns[columnName].type === "Select";
                        const isButtonName = columns[columnName].text;
                        const hasIcon = columns[columnName].icon;

                        return (
                          visibleColumns[columnName] &&
                          (item[columnName] !== null &&
                            item[columnName] !== undefined ? (
                              !isSelectColumn ? (
                                <OverlayTrigger
                                  key={columnName}
                                  placement="auto"
                                  overlay={
                                    <Tooltip id={`tooltip-${columnName}`}>
                                      {isDateColumn
                                        ? formatDate(item[columnName]) // Handle date column formatting
                                        : item[columnName]}
                                    </Tooltip>
                                  }
                                >
                                  <td
                                    className={`text-${columnAlignment} text-truncate`}
                                    style={{
                                      maxWidth: columnWidth || "100px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {isButtonColumn ? (
                                      <button
                                        className={`text-${columnAlignment} custom-btn`}
                                        onClick={() => handleBtn(columnName, item)}
                                      >
                                        {isButtonName}
                                      </button>
                                    ) : hasIcon ? (
                                      <div
                                        className="d-flex align-items-center justify-content-center text-center"
                                        onClick={() => handleIconClick(columnName, item)}
                                      >
                                        <span className="me-2">{icons[columns[columnName].icon]}</span>
                                        {item[columnName]}
                                      </div>
                                    ) : isDateColumn ? (
                                      formatDate(item[columnName])
                                    ) : isModalColumn ? (
                                      <a
                                        style={{ cursor: "pointer" }}
                                        className="text-info text-decoration-none"
                                        onClick={() => handleModalColumn(columnName, item)}
                                      >
                                        {item[columnName]}
                                      </a>
                                    ) : isImageColumn ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "50px",
                                            height: "50px",
                                            borderRadius: "50%",
                                            backgroundColor: "gray",
                                          }}
                                        ></div>
                                      </div>
                                    ) : isLinkColumn ? (
                                      <a
                                        style={{ cursor: "pointer" }}
                                        className="text-info text-decoration-none"
                                        onClick={() => console.log("LinkColumn", columnName, item)}
                                        href={item.FilePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {item[columnName]}
                                      </a>
                                    ) : (
                                      item[columnName]
                                    )}
                                  </td>
                                </OverlayTrigger>
                              ) : (
                                <td
                                  className={`text-${columnAlignment} text-truncate`}
                                  style={{
                                    maxWidth: columnWidth || "100px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {isButtonColumn ? (
                                    <button
                                      className={`text-${columnAlignment} custom-btn`}
                                      onClick={() => handleBtn(columnName, item)}
                                    >
                                      {isButtonName}
                                    </button>
                                  ) : hasIcon ? (
                                    <div
                                      className="d-flex align-items-center justify-content-center text-center"
                                      onClick={() => handleIconClick(columnName, item)}
                                    >
                                      <span className="me-2">{icons[columns[columnName].icon]}</span>
                                      {item[columnName]}
                                    </div>
                                  ) : isDateColumn ? (
                                    formatDate(item[columnName])
                                  ) : isModalColumn ? (
                                    <a
                                      style={{ cursor: "pointer" }}
                                      className="text-info text-decoration-none"
                                      onClick={() => handleModalColumn(columnName, item)}
                                    >
                                      {item[columnName]}
                                    </a>
                                  ) : isImageColumn ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                          borderRadius: "50%",
                                          backgroundColor: "gray",
                                        }}
                                      ></div>
                                    </div>
                                  ) : isLinkColumn ? (
                                    <a
                                      style={{ cursor: "pointer" }}
                                      className="text-info text-decoration-none"
                                      onClick={() => console.log("LinkColumn", columnName, item)}
                                      href={item.FilePath}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item[columnName]}
                                    </a>
                                  ) : isSelectColumn ? (
                                    <Select
                                      name={columnName}
                                      onChange={(selectedOption, action) => {
                                        handleColumnSelect(selectedOption, item);
                                        setDropdownValue((prevState) => ({
                                          ...prevState,
                                          [item.ID]: {
                                            ...prevState[item.ID],
                                            [columnName]: selectedOption,
                                          },
                                        }));
                                      }}
                                      isDisabled={item[columnName] === 6842}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      value={
                                        dropDownValue[item.ID]?.[columnName] ||
                                        columns[columnName]?.option?.find((o) => o.value === Number(item[columnName])) ||
                                        { value: null, label: "Select" }
                                      }
                                      options={[
                                        { value: null, label: "Select" },
                                        ...(columns[columnName]?.option || []),
                                      ]}
                                    />
                                  ) : (
                                    item[columnName]
                                  )}
                                </td>
                              )
                              
                          ) : (
                            <td
                              key={columnName}
                              className={`text-${columnAlignment} text-truncate`}
                              style={{
                                maxWidth: columnWidth || "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {isButtonColumn ? (
                                <button
                                  className={`text-${columnAlignment} custom-btn`}
                                  onClick={() => handleBtn(columnName, item)}
                                >
                                  {isButtonName}
                                </button>
                              ) : hasIcon ? (
                                // <OverlayTrigger
                                //   placement="bottom"
                                //   overlay={
                                //     <Tooltip id="tooltip-bottom">
                                //       {item[columns[columnName].iconText] || "Edit"}
                                //     </Tooltip>
                                //   }
                                // >
                                <div
                                  className="d-flex align-items-center justify-content-center text-center"
                                  onClick={() => handleIconClick(columnName, item)}
                                >
                                  <span className="me-2">
                                    {icons[columns[columnName].icon]}
                                  </span>
                                  {item[columnName]}
                                </div>
                              ) : // </OverlayTrigger>
                                isDateColumn ? (
                                  formatDate(item[columnName])
                                ) : (
                                  item[columnName] ? item[columnName] : '-'
                                )}
                            </td>
                          ))
                        );
                      })}
                      {isActionRequired && (
                        <td>
                          <div className="d-flex justify-content-center text-center">
                            {showIcon1 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon1Text || "Edit"}
                                  </Tooltip>
                                }
                              >
                                <div

                                  // onClick={() => handleIcon1(item)}
                                  className={`me-2 ${item[icons.Icon1Flag] === 0 ? "disabled-icon" : ""}`}
                                  onClick={() => {
                                    if (item[icons.Icon1Flag] !== 0) handleIcon1(item);
                                  }}

                                >
                                  {icons.Icon1}
                                </div>

                              </OverlayTrigger>
                            )}
                            {showIcon2 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon2Text || "Edit"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className="me-2"
                                  onClick={() => handleIcon2(item)}
                                >
                                  {icons.Icon2}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon3 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon3Text}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className="me-2"
                                  onClick={() => handleIcon3(item)}
                                >
                                  {icons.Icon3}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon4 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon4Text || "Add"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className="me-2"
                                  onClick={() => handleIcon4(item)}
                                >
                                  {icons.Icon4}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon5 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon5Text || "Add"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className="me-2"
                                  onClick={() => handleIcon5(item)}
                                >
                                  {icons.Icon5}
                                </div>
                              </OverlayTrigger>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              ) : isApiStatus === 200 && currentData?.length === 0
                ? (
                  <tbody>
                    <tr>
                      <td
                        colSpan={
                          Object.keys(columns).length +
                          (isCheckBoxRequired ? 1 : 0) +
                          (isActionRequired ? 1 : 0) +
                          (isSrNoRequired ? 1 : 0)
                        }
                        className="text-center"
                      >
                        <p>No Data Found</p>
                      </td>
                    </tr>
                  </tbody>
                ) : isApiStatus === undefined 
                  ? (
                    <tbody>
                      <tr>
                        <td
                          colSpan={
                            Object.keys(columns).length +
                            (isCheckBoxRequired ? 1 : 0) +
                            (isActionRequired ? 1 : 0)
                          }
                          className="text-center"
                        >
                          <div>
                            <p>
                              <FaSpinner class="spinner" />
                              <br />
                              Loading
                            </p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ) :
                  // isApiStatus !== 200 && currentData?.length === 0 
                  (
                    <tbody>
                      <tr>
                        <td
                          colSpan={
                            Object.keys(columns).length +
                            (isCheckBoxRequired ? 1 : 0) +
                            (isActionRequired ? 1 : 0)
                          }
                          className="text-center"
                        >
                          <p>No Data Found</p>
                        </td>
                      </tr>
                    </tbody>
                  )
              ) :
              (currentData?.length != 0 ? (
                <tbody>
                  {currentData.map((item, index) => (
                    <tr key={index}>
                      {isCheckBoxRequired && (
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={
                              !!selectedResource.find(
                                (o) => o.EmployeeID === item.EmployeeID
                              )
                            }
                            onChange={(e) =>
                              handleCheckboxChange(e, item.EmployeeID, item)
                            }
                          />
                        </td>
                      )}
                          {isSrNoRequired && (
                      <td className="text-center">{index + 1}</td>
                    )}
                      {Object.keys(columns).map((columnName) => {
                        const isDateColumn =
                          columns[columnName].text.toLowerCase().includes("date") ||
                          columns[columnName].text
                            .toLowerCase()
                            .includes("on bench since");

                        const columnAlignment = columns[columnName].align || "left";
                        const columnWidth = columns[columnName].width;

                        const isButtonColumn =
                          columns[columnName].type === "button";
                        const isModalColumn = columns[columnName].type === "Modal";
                        const isImageColumn = columns[columnName].type === "Image";
                        const isLinkColumn = columns[columnName].type === "Link";
                        const isSelectColumn = columns[columnName].type === "Select";
                        const isButtonName = columns[columnName].text;
                        const hasIcon = columns[columnName].icon;

                        return (
                          visibleColumns[columnName] &&
                          (item[columnName] !== null &&
                            item[columnName] !== undefined ? (
                            <OverlayTrigger
                              key={columnName}
                              placement="auto"
                              overlay={
                                <Tooltip id={`tooltip-${columnName}`}>
                                  {isDateColumn
                                    ? formatDate(item[columnName])
                                    : item[columnName]}
                                </Tooltip>
                              }
                            >
                              <td
                                className={`text-${columnAlignment} text-truncate`}
                                style={{
                                  maxWidth: columnWidth || "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {isButtonColumn ? (
                                  <button
                                    className={`text-${columnAlignment} custom-btn`}
                                    onClick={() => handleBtn(columnName, item)}
                                  >
                                    {isButtonName}
                                  </button>
                                ) : hasIcon ? (
                                  <div
                                    className="d-flex align-items-center justify-content-center text-center"
                                    onClick={() =>
                                      handleIconClick(columnName, item)
                                    }
                                  >
                                    <span className="me-2">
                                      {icons[columns[columnName].icon]}
                                    </span>
                                    {item[columnName]}
                                  </div>
                                ) : isDateColumn ? (
                                  formatDate(item[columnName])
                                ) : isModalColumn ? (
                                  <a
                                    style={{ cursor: "pointer" }}
                                    className="text-info text-decoration-none"
                                    onClick={() =>
                                      handleModalColumn(columnName, item)
                                    }
                                  >
                                    {" "}
                                    {item[columnName]}
                                  </a>
                                ) : isImageColumn ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                        backgroundColor: "gray",
                                      }}
                                    ></div>
                                  </div>
                                ) : isLinkColumn ? (
                                  <a
                                    style={{ cursor: "pointer" }}
                                    className="text-info text-decoration-none"
                                    onClick={() =>
                                      console.log("LinkColumn", columnName, item)
                                    }
                                    href={item.FilePath}
                                    target="_blank"
                                  >
                                    {" "}
                                    {item[columnName]}
                                  </a>
                                ) : isSelectColumn ?
                                  (
                                    <>
                                      <Select
                                        name={columnName} // Use unique column name
                                        onChange={(selectedOption, action) => {
                                          // Update the value of the selected option for this specific row and column
                                          handleColumnSelect(selectedOption, item);

                                          // Update the state for the current row and column
                                          setDropdownValue((prevState) => ({
                                            ...prevState,
                                            [item.ID]: {
                                              ...prevState[item.ID], // Keep previous state for this row intact
                                              [columnName]: selectedOption // Update only for this column of the current row
                                            }
                                          }));
                                        }}
                                        isDisabled={item[columnName] === 6827} // Simplified the condition
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                        }}
                                        value={
                                          dropDownValue[item.ID]?.[columnName] // Get value for this specific row and column
                                          || columns[columnName]?.option?.find((o) => o.value === item[columnName]) // Ensure options are correctly referenced
                                          || { value: null, label: "Select" }
                                        }
                                        options={[
                                          { value: null, label: "Select" },
                                          ...(columns[columnName]?.option || []), // Ensure options are provided safely
                                        ]}

                                      />



                                    </>
                                  )
                                  : (
                                    item[columnName]
                                  )}
                              </td>
                            </OverlayTrigger>
                          ) : (
                            <td
                              key={columnName}
                              className={`text-${columnAlignment} text-truncate`}
                              style={{
                                maxWidth: columnWidth || "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {isButtonColumn ? (
                                <button
                                  className={`text-${columnAlignment} custom-btn`}
                                  onClick={() => handleBtn(columnName, item)}
                                >
                                  {isButtonName}
                                </button>
                              ) : hasIcon ? (
                                // <OverlayTrigger
                                //   placement="bottom"
                                //   overlay={
                                //     <Tooltip id="tooltip-bottom">
                                //       {item[columns[columnName].iconText] || "Edit"}
                                //     </Tooltip>
                                //   }
                                // >
                                <div
                                  className="d-flex align-items-center justify-content-center text-center"
                                  onClick={() => handleIconClick(columnName, item)}
                                >
                                  <span className="me-2">
                                    {icons[columns[columnName].icon]}
                                  </span>
                                  {item[columnName]}
                                </div>
                              ) : // </OverlayTrigger>
                                isDateColumn ? (
                                  formatDate(item[columnName])
                                ) : (
                                  item[columnName] ? item[columnName] : '-'
                                )}
                            </td>
                          ))
                        );
                      })}
                      {isActionRequired && (
                        <td>
                          <div className="d-flex justify-content-center text-center">
                            {showIcon1 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon1Text || "Edit"}
                                  </Tooltip>
                                }
                              >
                                <div

                                  // onClick={() => handleIcon1(item)}
                                  className={`me-2 ${item[icons.Icon1Flag] === 0 ? "disabled-icon" : ""}`}
                                  onClick={() => {
                                    if (item[icons.Icon1Flag] !== 0) handleIcon1(item);
                                  }}

                                >
                                  {icons.Icon1}
                                </div>

                              </OverlayTrigger>
                            )}
                            {showIcon2 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon2Text || "Edit"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className="me-2"
                                  onClick={() => handleIcon2(item)}
                                >
                                  {icons.Icon2}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon3 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon3Text}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className="me-2"
                                  onClick={() => handleIcon3(item)}
                                >
                                  {icons.Icon3}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon4 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon4Text || "Add"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className="me-2"
                                  onClick={() => handleIcon4(item)}
                                >
                                  {icons.Icon4}
                                </div>
                              </OverlayTrigger>
                            )}
                            {showIcon5 && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    {icons.Icon5Text || "Add"}
                                  </Tooltip>
                                }
                              >
                                <div
                                  className="me-2"
                                  onClick={() => handleIcon5(item)}
                                >
                                  {icons.Icon5}
                                </div>
                              </OverlayTrigger>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0) +
                        (isSrNoRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <div>
                        <p>

                          <FaSpinner class="spinner" />
                          <br />
                          Loading
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              ))}
          </Table></div>
        {/* {filteredData.length > itemsPerPage && ( */}
     <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between mb-3">
  {/* Text and per-page dropdown - stacked on small screens, inline on larger */}
  <div className="d-flex justify-content-between px-2">
    <span style={{ width: "110px" }}>
      Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
      {Math.min(
        currentPage * selectedRecordsPerPage,
        filteredData.length
      )}{" "}
      of {filteredData.length}
    </span>

    <div style={{ width: "80px" }}>
      <select
        value={selectedRecordsPerPage}
        onChange={handleRecordsPerPage}
        className="mx-2 form-select form-select-sm"
      >
        {recordsPerPageOption.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  </div>

  {/* Pagination - centered on small screens, right-aligned on larger */}
  <div className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0 w-100">
    <Pagination
      itemsPerPage={itemsPerPage}
      totalItems={filteredData.length}
      currentPage={currentPage}
      onPageChange={handlePageChange}
    />
  </div>
</div>
        {/* )} */}
      </div>
    </div>
  );
};

export default SupportTicketTable;
